import BaseService from 'services/BaseService';

export default class InternalStaticAnchorService extends BaseService {
	_type = 'internalStaticAnchor';
	_typeKey = 'type';
}
